import { render } from "./JSONTreeView.vue?vue&type=template&id=d8ac5daa&scoped=true&ts=true"
import script from "./JSONTreeView.vue?vue&type=script&lang=ts"
export * from "./JSONTreeView.vue?vue&type=script&lang=ts"

import "./JSONTreeView.vue?vue&type=style&index=0&id=d8ac5daa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8ac5daa"]])

export default __exports__